import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import './BookCategoryPage.css';

const baseUrl = process.env.REACT_APP_BASE_URL;

function BookCategoryPage() {
  const { language } = useParams();
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch categories on component mount
  useEffect(() => {
    const fetchCategories = async (lang) => {
      try {
        setLoading(true);
        const response = await axios.get(`${baseUrl}/ivr/display-categories/${lang}`, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        let data = response.data;
        data = data.slice(5);
        setCategories([...data]);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchLanguages = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${baseUrl}/language`, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        const data = response.data;
        setLanguages(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    // fetchCategories();

    fetchLanguages()
      .then(() => {
        let selectedLanguageFromStorage = localStorage.getItem('currentLanguage');
        if (selectedLanguageFromStorage) {
          setSelectedLanguage(selectedLanguageFromStorage);
        } else {
          if (!selectedLanguage) {
            selectedLanguageFromStorage = 'Hindi';
            setSelectedLanguage(selectedLanguageFromStorage)
            localStorage.setItem('currentLanguage', selectedLanguageFromStorage);
          }
        }
        return selectedLanguageFromStorage;
      }).then(async (lang) => {
        await fetchCategories(lang)
      });
  }, []);

  const handleCategoryClick = (category) => {
    localStorage.setItem('currentCategory', category);
  };

  const handleLanguageChange = async (event) => {
    const lang = event.target.value;
    setSelectedLanguage(lang);
    localStorage.setItem('currentLanguage', lang);
  };

  return (
    <div className='container' style={{ padding: '20px', textAlign: 'center' }}>
      <section className="header-wrap d-flex justify-content-start align-items-center">
        <button onClick={() => { navigate(-1); }} className="btn btn-secondary">
          Go Back
        </button>
        <h1 className="logo my-auto ms-4">
          <span className="assistive-text">Shravan Audiobooks Library</span>
        </h1>
      </section>
      <div className='d-flex flex-column mt-5 justify-content-center align-items-start category-container'>

        <div className='d-flex flex-row flex-wrap justify-content-end align-items-center w-100'>
          <h2 className='me-3 my-auto text-left language-font'>Select a language</h2>
          <select className='form-select w-auto' value={selectedLanguage} onChange={handleLanguageChange}>
            {
              languages && languages.map((lang) => (
                <option key={lang.language.toLowerCase()} value={lang.language}>
                  {lang.language}
                </option>
              ))
            }
          </select>
        </div>

        <div className='d-flex flex-row flex-wrap justify-content-between align-items-center w-100'>
          <h2 className='me-3 text-left'>Choose one book category</h2>

          <ul className='list-group category-list w-100'>
            {
              categories.map((cat, idx) => (
                <li key={idx} className='list-group-item category-item'>
                  <Link
                    to={`/category/${selectedLanguage}/books/${cat}`}
                    onClick={() => { handleCategoryClick(cat) }}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <div className="result-data d-flex justify-content-start align-items-baseline">
                      <p className='mb-0'>{idx + 1}. {cat}</p>
                    </div>
                  </Link>
                </li>
              ))
            }
            {/* <li key='cat-1' className='list-group-item category-item'>
              <Link
                to={`/category/${selectedLanguage}/${categories[0]}`}
                onClick={() => { handleCategoryClick(categories[0]) }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <h3 className='mb-0'>1. {categories[0]}</h3>
                </div>
              </Link>
            </li>

            <li key='cat-2' className='list-group-item category-item'>
              <Link
                to={`/category/${selectedLanguage}/${categories[1]}`}
                onClick={() => { handleCategoryClick(categories[1]) }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <h3 className='mb-0'>2. {categories[1]}</h3>
                </div>
              </Link>
            </li>

            <li key='cat-3' className='list-group-item category-item'>
              <Link
                to={`/category/${selectedLanguage}/${categories[2]}`}
                onClick={() => { handleCategoryClick(categories[2]) }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <h3 className='mb-0'>3. {categories[2]}</h3>
                </div>
              </Link>
            </li>

            <li key='cat-4' className='list-group-item category-item'>
              <Link
                to={`/category/${selectedLanguage}/${categories[3]}`}
                onClick={() => { handleCategoryClick(categories[3]) }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <div className="result-data d-flex justify-content-start align-items-baseline">
                  <h3 className='mb-0'>4. {categories[3]}</h3>
                </div>
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
      {loading && <p>Loading books...</p>}
      {error && <p style={{ color: 'red' }}>Error: {error}</p>}
    </div >
  );
}

export default BookCategoryPage;
